module.exports = __webpack_public_path__ + "img/logo-pp.54b640db.png";